module.exports = __webpack_public_path__ + "img/pos-leaderboard-badge-rank-1.8f2a68cd.svg";